import { useTranslation } from "react-i18next";
import images from "../../../../images";

const CompletedAllQuest = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start gap-6 w-full">
      <div className="relative flex flex-col h-[206px] p-[18px] items-start self-stretch rounded-[6px] bg-[#ECEEFF] shadow-[0_0_8px_0_rgba(0,0,0,0.10)] overflow-hidden">
        <button
          onClick={onClose}
          className="absolute right-[10px] top-[10px] w-[30px] h-[30px] flex items-center justify-center cursor-pointer z-20 hover:opacity-70 transition-opacity"
        >
          <img
            src={images.CloseModalIconGray || images.CloseIcon}
            alt="Close"
            className="w-3 h-3"
            style={{
              filter:
                "invert(18%) sepia(86%) saturate(5833%) hue-rotate(238deg) brightness(90%) contrast(96%)",
            }}
          />
        </button>

        <div className="relative z-10 flex w-[233px] flex-col items-start gap-6">
          <h3 className="text-[#253FF6] font-bold text-2xl leading-tight text-left">
            {t("quest.completedQuest.youveCompletedAllTheQuests") ||
              "You've completed all the quests!"}
          </h3>
          <p className="text-[#253FF6] text-base font-medium text-left">
            {t("quest.completedQuest.swingByAgain") ===
            "quest.completedQuest.swingByAgain"
              ? "Swing by again!"
              : t("quest.completedQuest.swingByAgain") || "Swing by again!"}
          </p>
        </div>

        <img
          src={images.CompleteQuestImagePerLocation}
          alt="Completed Quest Illustration"
          className="absolute right-[26px] bottom-[16px] w-[143px] h-[143px] object-contain z-0 pointer-events-none"
        />
      </div>
    </div>
  );
};

export default CompletedAllQuest;
